<template>
  <div class="container">
    <div class="likes">
      <el-icon name="heart" @click="addLike"></el-icon>
      {{ likes }}
    </div>
    <div class="views">
      <el-icon name="view"></el-icon>
      {{ views }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      likes: 0,
      views: 100
    }
  },
  methods: {
    addLike() {
      this.likes++
    }
  }
}
</script>

<style>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.likes {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.views {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/login/Login.vue